webpackJsonp([137979575337702],{

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ValuePagesTemplate = __webpack_require__(74);
	
	var _ValuePagesTemplate2 = _interopRequireDefault(_ValuePagesTemplate);
	
	var _Text = __webpack_require__(55);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PageTitle = __webpack_require__(54);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrustPage = function TrustPage() {
	  return _react2.default.createElement(
	    _ValuePagesTemplate2.default,
	    null,
	    _react2.default.createElement(_PageTitle2.default, { title: 'Trust' }),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      'We believe in autonomy and independence as a way to grow. We trust who we work with to take the lead.'
	    ),
	    _react2.default.createElement(
	      _Text2.default,
	      null,
	      'We expect mistakes and we take responsibility.'
	    )
	  );
	};
	
	exports.default = TrustPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-trust-js-98b7e4faa2639f9d19a4.js